<template>
    <!--弹窗-->
    <el-dialog v-if="visible" width="900px" :title="title" :visible.sync="visible" :before-close="handleClose">
        <div class="chart-datepicker">
            <div class="range-option" @click="getList(charts_id, 30)" :style="index == 30 ? 'font-weight: bold;color: #508cfd;' : ''">30 天</div>
            <div class="range-option" @click="getList(charts_id, 90)" :style="index == 90 ? 'font-weight: bold;color: #508cfd;' : ''">90 天</div>
            <div class="range-option" @click="getList(charts_id, 365)" :style="index == 365 ? 'font-weight: bold;color: #508cfd;' : ''">1 年</div>
            <div class="range-option" @click="getList(charts_id, null)" :style="index == null ? 'font-weight: bold;color: #508cfd;' : ''">全部</div>
        </div>
        <div v-loading="loading" :id="'highcharts-' + charts_id" style="min-height: 400px;"></div>
        <el-divider></el-divider>
    </el-dialog>
</template>
<script>
import * as api from "@/api/Product/Product";
import * as Highcharts from "highcharts";
import * as loadExporting from "highcharts/modules/exporting";
import * as exportExcel from "highcharts/modules/export-data.src";
loadExporting(Highcharts);
exportExcel(Highcharts);
export default {
    data() {
        return {
            loading: false,
            index: 0
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        charts_id: {
            type: String,
            default: "0"
        },
        charts_keyword: {
            type: String,
            default: ""
        }
    },
    methods: {
        getList(id, index) {
            if (this.index == index) return;
            this.index = index;
            this.loading = true;
            api.competitors_in_rank_trend_batch({
                keyword_ids: [id],
                days: index
            })
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.getCharts(res.data[id].date, res.data[id].count);
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getCharts(date, data) {
            Highcharts.chart("highcharts-" + this.charts_id, {
                chart: {
                    type: "line"
                },
                title: {
                    text: null
                },
                yAxis: {
                    allowDecimals: false,
                    min: 0,
                    title: {
                        text: null
                    }
                },
                xAxis: {
                    categories: date,
                    title: {
                        text: "DateTime"
                    },
                    tickInterval: Math.ceil(date.length / 6),
                    tickWidth: 1
                },
                tooltip: {
                    crosshairs: [
                        {
                            width: 1,
                            color: "#ddd"
                        }
                    ],
                    pointFormat: `<br/><div style="color: rgb(134, 178, 234) !important;">你的产品</div><br/>数量: <b>{point.y}</b><br/><br/>`
                },
                plotOptions: {
                    series: {
                        cursor: "pointer",
                        label: {
                            connectorAllowed: false
                        },
                        events: {
                            click: function(event) {
                                // console.log(event.point.options);
                                console.log(event.point);
                            }
                        }
                    }
                },
                legend: {
                    enabled: false
                },
                credits: { enabled: false },
                series: [{ data: data, name: "数量" }],
                responsive: {
                    rules: [
                        {
                            condition: {
                                maxWidth: 500
                            },
                            chartOptions: {
                                legend: {
                                    layout: "horizontal",
                                    align: "center",
                                    verticalAlign: "bottom"
                                }
                            }
                        }
                    ]
                },
                exporting: {
                    filename: `${this.title} (数据统计图)`,
                    menuItemDefinitions: {
                        printChart: {
                            text: "打印图表"
                        },
                        downloadJPEG: {
                            text: "下载JPEG 图片"
                        },
                        downloadPDF: {
                            text: "下载PDF 文档"
                        },
                        downloadPNG: {
                            text: "下载PNG 图片"
                        },
                        downloadSVG: {
                            text: "下载SVG 矢量图"
                        },
                        exportButtonTitle: {
                            text: "导出图片"
                        },
                        downloadCSV: {
                            text: "下载CSV 数据表"
                        },
                        downloadXLS: {
                            text: "下载XLS 数据表"
                        }
                    },
                    buttons: {
                        contextButton: {
                            menuItems: [
                                "printChart",
                                "separator",
                                "downloadJPEG",
                                "downloadPDF",
                                "downloadPNG",
                                "downloadSVG",
                                "separator",
                                "downloadCSV",
                                "downloadXLS"
                            ]
                        }
                    }
                }
            });
        },
        // 关闭弹窗
        handleClose() {
            this.index = 0;
            this.loading = false;
            this.$emit("close-callback", true);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.chart-datepicker {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    margin-bottom: 20px;
}
.range-option {
    font-size: 13px;
    color: #3a3a3a;
    padding: 0 10px;
    text-decoration: underline;
    cursor: pointer;
}
.range-option:hover {
    color: #666;
    text-decoration: none;
}
.phrase-stats {
    margin-left: 10px;
    margin-bottom: 10px;
    div {
        line-height: 30px;
        font-weight: 700;
        font-size: 16px;
    }
    span {
        margin-right: 5px;
    }
}
.stat-top-info {
    display: inline-block;
}
/deep/ .el-dialog__body {
    padding: 10px 20px 20px 20px !important;
}
</style>
